export const mnaQuestions = [
  {
    id: "foodIntake",
    question: "A. 過去3個月內有沒有因為食慾不振、消化問題、咀嚼或吞嚥困難而減少食量？",
    options: [
      {value: 0, label: "食量嚴重減少"},
      {value: 1, label: "食量中度減少"},
      {value: 2, label: "食量沒有改變"},
    ],
  },
  {
    id: "weightLoss",
    question: "B. 過去三個月內體重下降的情況？",
    options: [
      {value: 0, label: "體重下降大於3公斤"},
      {value: 1, label: "不知道"},
      {value: 2, label: "體重下降1~3公斤"},
      {value: 3, label: "體重沒有下降"},
    ],
  },
  {
    id: "mobility",
    question: "C. 活動能力",
    options: [
      {value: 0, label: "需長期臥床或輪椅"},
      {value: 1, label: "可以下床或離開輪椅，但不能外出"},
      {value: 2, label: "可以外出"},
    ],
  },
  {
    id: "stress",
    question: "D. 過去三個月內有沒有受到心理創傷或患上急性疾病？",
    options: [
      {value: 0, label: "有"},
      {value: 2, label: "無"},
    ],
  },
  {
    id: "cognitive",
    question: "E. 精神心理問題？",
    options: [
      {value: 0, label: "嚴重痴呆或抑鬱"},
      {value: 1, label: "輕度痴呆"},
      {value: 2, label: "沒有精神心理問題"},
    ],
  },
  {
    id: "bmi",
    question: "F. 身體質量指數(BMI)",
    options: [
      {value: 0, label: "BMI <19"},
      {value: 1, label: "BMI 19~21"},
      {value: 2, label: "BMI 21~23"},
      {value: 3, label: "BMI>=23"},
    ],
  },
];
